import * as React from "react";

function SvgBelts(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <circle cx={16.95} cy={10} r={1.01} />
      <path d="M19.44 6.05h-4.33V4.57c0-.28-.22-.5-.5-.5H6.39c-.28 0-.5.22-.5.5v1.46h-.36c-.03 0-.06.01-.09.02h-.4V4.57c0-.28-.22-.5-.5-.5H2.51c-.28 0-.5.22-.5.5v1.48H.56c-.28 0-.5.22-.5.5v6.9c0 .28.22.5.5.5H2v1.46c0 .28.22.5.5.5h2.03c.28 0 .5-.22.5-.5v-1.46h.84v1.46c0 .28.22.5.5.5h8.23c.28 0 .5-.22.5-.5v-1.46h4.33c.28 0 .5-.22.5-.5v-6.9c.01-.28-.22-.5-.49-.5zm-17.43 6.9h-.95v-5.9H2v5.9zm2.03 1.96H3.01V5.07h1.03v9.84zm1-1.96v-5.9H12v1.86H8.53c-.28 0-.5.22-.5.5v1.16c0 .28.22.5.5.5H12v1.88H5.04zm7.94-3.04v.16H9.03v-.16h3.95zm1.13 5H6.89v-.96h5.62c.28 0 .5-.22.5-.5v-2.38h.48c.28 0 .5-.22.5-.5V9.41c0-.28-.22-.5-.5-.5H13V6.53c0-.28-.22-.5-.5-.5H6.89v-.96h7.23v9.84zm4.83-1.96h-3.83v-5.9h3.83v5.9z" />
    </svg>
  );
}

export default SvgBelts;
